<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/finance/riskControl_new";
export default {
  name: "",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        ...apis
      },
      config: {},
      footer: {},
      modals: {
        remarks: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({ client_ids: row.client_ids });
              this.$page
                .handleRequestMethods("setRemarks", data, true, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$tz("设置,备注"),
            modalBind: {
              width: 500
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ remarks: 24 }],
          fields: [
            {
              key: "remarks",
              name: () => this.$tz("备注"),
              placeholder() {
                return this.$tz("备注");
              },
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 4 }
              }
            }
          ]
        },
        status: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({ client_ids: row.client_ids });
              this.$page
                .handleRequestMethods("setStatus", data, true, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$tz("设置状态"),
            modalBind: {
              width: 600
            },
            formBind: {
              labelWidth: 150
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              status: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              start_time: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "date"
                }
              ],
              end_time: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "date"
                }
              ]
            }
          },
          grid: [
            { operator_name: 24 },
            { create_time: 24 },
            { status: 24 },
            { start_time: 24 },
            { end_time: 24 },
            { remarks: 24 }
          ],
          fields: [
            {
              name: () => this.$tz("操作人"),
              key: "operator_name",
              component: "Input",
              disabled: true,
              placeholder: () => this.$tz("操作人"),
              show: ({ value }) => !!value
            },
            {
              name: () => this.$tz("操作人"),
              key: "create_time",
              component: "Input",
              disabled: true,
              placeholder: () => this.$tz("操作人"),
              show: ({ value }) => !!value
            },
            {
              name: this.$tz("状态"),
              key: "status",
              component: "Radio",
              options: [],
              optionsFn: "NormalDisable",
              optionsKey: "",
              default: "DISABLE",
              bind: {
                border: true
              }
            },
            {
              name: () => this.$tz("有效期,开始,时间"),
              key: "start_time",
              placeholder: () => this.$tz("有效期,开始,时间"),
              component: "DatePicker",
              disabledDate: true,
              show({ row }) {
                return row.status === "DISABLE";
              },
              format: "YYYY-MM-DD HH:mm:ss",
              bind: {
                type: "datetime",
                format: "yyyy-MM-dd HH:mm:ss"
              }
            },
            {
              name: () => this.$tz("有效期,结束,时间"),
              key: "end_time",
              placeholder: () => this.$tz("有效期,结束,时间"),
              component: "DatePicker",
              disabledDate: true,
              format: "YYYY-MM-DD HH:mm:ss",
              show({ row }) {
                return row.status === "DISABLE";
              },
              bind: {
                type: "datetime",
                format: "yyyy-MM-dd HH:mm:ss"
              }
            },
            {
              key: "remarks",
              name: () => this.$tz("备注"),
              placeholder() {
                return this.$tz("备注");
              },
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 3 }
              }
            }
          ]
        },
        detail1: {
          config: {
            title: this.$tz("期初明细"),
            modalBind: {
              width: 1000
            }
          },
          footer: {
            show: () => false
          },
          table: {
            config: {
              height: 600
            },
            fields: [
              {
                name: () => this.$tz("月度"),
                width: 110,
                children: [
                  "date_year",
                  "prev_year",
                  ...Array(12)
                    .fill(1)
                    .map((_, i) => i + 1)
                ].map(t => {
                  let data = {
                    name:
                      t === "date_year"
                        ? this.$tz("年份")
                        : t === "prev_year"
                        ? this.$tz("上一年,结余")
                        : this.$tz(t + "月"),
                    key: typeof t === "number" ? "month_" + t : t,
                    width: 95
                    // total: t !== "date_year",
                  };
                  return data;
                })
              },
              {
                name: () => this.$tz("电商部,-,总应收款"),
                key: "total_receivable",
                minWidth: 110
                // total: true
              },
              {
                name: () => this.$tz("币种"),
                key: "total_receivable_currency",
                minWidth: 110
              },
              {
                name: () => this.$tz("上传时间"),
                key: "create_time",
                minWidth: 110
              },
              {
                name: () => this.$tz("操作人"),
                key: "operator_name",
                minWidth: 110
              }
            ]
          }
        },
        detail: {
          config: {
            title: this.$tz("详情"),
            modalBind: {
              width: 1000
            }
          },
          footer: {
            show: () => false
          },
          table: {
            config: {
              height: 600
            },
            fields: [
              {
                name: () => this.$tz("账单号"),
                key: "bill_number",
                minWidth: 110
              },
              {
                name: () => this.$tz("应收,金额"),
                key: "to_amount",
                minWidth: 110,
                columnBind: {
                  sortable: true
                }
              },
              {
                name: () => this.$tz("出单时间"),
                key: "bill_create_time",
                minWidth: 110,
                columnBind: {
                  sortable: true
                }
              },
              {
                name: () => this.$tz("部分,核销,金额"),
                key: "off_amount",
                minWidth: 110
              },
              {
                name: () => this.$tz("账单,类型"),
                key: "bill_data_type",
                minWidth: 110
              }
            ]
          }
        }
      },
      header: {
        config: {
          searchLength: 12
        },
        searchs: [
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              type: "date",
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              type: "date",
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            options: [],
            optionsFn: "customer"
          },
          {
            key: "salesman_id",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            component: "Select",
            options: [],
            optionsFn: "salesman"
          },
          {
            key: "ownership",
            placeholder() {
              return this.$tz("所属公司");
            },
            component: "Select",
            options: [],
            optionsFn: "getCompanies",
            optionsKey: ""
          },
          {
            key: "target_type",
            component: "Select",
            placeholder: () => this.$t("select") + this.$t("CollectionUser"),
            clearable: true,
            options: [
              { label: this.$t("b2bClient"), value: 1 },
              { label: this.$t("branchOffice"), value: 2 }
            ]
          },
          {
            key: "start_credit_limit",
            placeholder() {
              return this.$tz("最小,额度");
            },
            component: "Input"
          },
          {
            key: "end_credit_limit",
            placeholder() {
              return this.$tz("最大,额度");
            },
            component: "Input"
          },
          {
            key: "currency",
            placeholder() {
              return this.$tz("币种");
            },
            component: "Select",
            options: [],
            optionsFn: "getCurrency",
            optionsKey: ""
          },
          {
            key: "lock_status",
            placeholder() {
              return this.$tz("状态");
            },
            component: "Select",
            options: [],
            optionsFn: "NormalDisable",
            optionsKey: ""
          },
          {
            key: "over_day",
            placeholder() {
              return this.$tz("超期");
            },
            component: "Select",
            options: [],
            optionsFn: "YesNo",
            optionsKey: ""
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("重新计算"),
              type: "recompute",
              fnName: "recompute",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$tz("设置,状态"),
              type: "status",
              fnName: "status",
              bind: {
                type: "primary"
              },
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: () => this.$tz("设置,备注"),
              type: "remarks",
              fnName: "remarks",
              bind: {
                type: "primary"
              },
              disabled() {
                return !this.selectAll.length;
              }
            }
          ],
          methods: {
            remarks() {
              this.getModal("remarks").open(
                { client_ids: this.selectAll.map(t => t.client_id) },
                function() {
                  this.setTitle(this.$tz("设置,备注"));
                }
              );
            },
            status() {
              this.getModal("status").open(
                { client_ids: this.selectAll.map(t => t.client_id) },
                function() {
                  this.setTitle(this.$tz("设置,状态"));
                }
              );
            },
            recompute() {
              this.$Modal.confirm({
                title: this.$tz("重新计算"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "reTotal",
                    { clientIds: this.selectAll.map(t => t.client_id) },
                    true,
                    true
                  ).then(res => {
                    this.getList();
                  });
                }
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 50,
          align: "center"
        },
        {
          name: () => this.$tz("所属公司"),
          key: "ownership_name",
          minWidth: 110
        },
        {
          name: () => this.$tz("业务"),
          key: "salesman_account",
          minWidth: 110
        },
        {
          name: () => this.$tz("客户"),
          key: "account",
          minWidth: 110
        },
        {
          name: () => this.$tz("公司中文名"),
          key: "shipper_company_cn",
          minWidth: 110
        },
        {
          name: () => this.$tz("结算周期"),
          key: "billing_cycle",
          minWidth: 110
        },
        {
          name: () => this.$tz("期初数据"),
          children: [
            {
              name: () => this.$tz("金额"),
              key: "finance_amount",
              minWidth: 110,
              disabled: ({ value }) => !value,
              component: "Button",
              bind: {
                type: "primary",
                size: "small"
              },
              methods: {
                render({ value }) {
                  return value || "-";
                },
                click({ row, field }) {
                  this.$page.getModal("detail1").open(null, function() {
                    this.list = row.finance_amount_list;
                    this.setTitle(this.$tz(field.name()) + `(${row.account})`);
                  });
                }
              }
            },
            {
              name: () => this.$tz("币种"),
              key: "finance_amount_currency",
              minWidth: 110
            }
          ]
        },
        {
          name: () => this.$tz("以前,应收,CNY"),
          key: "before_amount",
          minWidth: 110,
          show: () => false,
          type: "1",
          component: "Button",
          disabled: ({ value }) => !value,
          bind: {
            type: "primary",
            size: "small"
          },
          methods: {
            render({ value }) {
              return value || "-";
            },
            click({ row, field }) {
              this.$page
                .handleRequestMethods(
                  "detail",
                  { type: field.type, id: row.id },
                  false,
                  true
                )
                .then(res => {
                  this.$page.getModal("detail").open(null, function() {
                    this.list = res.payload;
                    this.setTitle(this.$tz(field.name()) + `(${row.account})`);
                  });
                });
            }
          }
        },
        {
          name: () => this.$tz("最新,应收,CNY"),
          key: "latest_amount",
          minWidth: 110,
          type: "2",
          disabled: ({ value }) => !value,
          component: "Button",
          bind: {
            type: "primary",
            size: "small"
          },
          methods: {
            render({ value }) {
              return value || "-";
            },
            click({ row, field }) {
              this.$page
                .handleRequestMethods(
                  "detail",
                  { type: field.type, id: row.id },
                  false,
                  true
                )
                .then(res => {
                  this.$page.getModal("detail").open(null, function() {
                    this.list = res.payload;
                    this.setTitle(this.$tz(field.name()) + `(${row.account})`);
                  });
                });
            }
          }
        },
        {
          name: () => this.$tz("总欠款,CNY"),
          key: "total_receivable",
          minWidth: 110,
          type: "3",
          component: "Button",
          bind: {
            type: "primary",
            size: "small"
          },
          disabled: ({ value }) => !value,
          methods: {
            render({ value }) {
              return value || "-";
            },
            click({ row, field }) {
              this.$page
                .handleRequestMethods(
                  "detail",
                  { type: field.type, id: row.id },
                  false,
                  true
                )
                .then(res => {
                  this.$page.getModal("detail").open(null, function() {
                    this.list = res.payload;
                    this.setTitle(this.$tz(field.name()) + `(${row.account})`);
                  });
                });
            }
          }
        },
        {
          name: () => this.$tz("信用额度,CNY"),
          key: "credit_limit",
          minWidth: 110
        },
        {
          name: () => this.$tz("超额"),
          key: "excess_amount",
          minWidth: 110
        },
        {
          name: () => this.$tz("超期"),
          key: "min_time",
          minWidth: 110
        },
        {
          name: () => this.$tz("状态"),
          key: "lock_status",
          minWidth: 110,
          component({ row }) {
            return row.lock_id ? "Button" : "";
          },
          bind: {
            type: "primary",
            size: "small"
          },
          methods: {
            click({ row }) {
              this.$page
                .handleRequestMethods(
                  "statusLog",
                  { id: row.client_id },
                  false,
                  true
                )
                .then(res => {
                  res.payload.client_ids = [row.client_id];
                  this.$page.getModal("status").open(res.payload, function() {
                    this.setTitle(this.$tz("操作,详情"));
                  });
                });
            }
          }
        },
        {
          name: () => this.$tz("备注"),
          key: "remarks",
          minWidth: 110
        },
        {
          name: () => this.$tz("其他,币种,转,CNY,汇率"),
          children: [
            "CNY",
            "USD",
            "KWD",
            "SAR",
            "QAR",
            "AED",
            "BHD",
            "JOD",
            "HKD",
            "OMR"
          ].map(item => {
            return {
              name: () => item,
              key: item.toLocaleLowerCase() + "_to_rate",
              minWidth: 110
            };
          })
        },
        {
          name: () => this.$tz("操作人"),
          key: "operator_name",
          minWidth: 110
        },
        {
          name: () => this.$tz("统计,时间"),
          key: "create_time",
          minWidth: 110
        }
      ]
    };
  }
};
</script>

<style scoped></style>
